import React, { useEffect, useMemo, useState } from 'react'
import { Box, CircularProgress, makeStyles } from '@material-ui/core'

import colors from '../../../assets/colors'

import 'react-quill/dist/quill.snow.css'

// Só o que o sanitizer do backend aceita: nada de size/font/indent (usam classes)
const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['blockquote', 'code-block'],
  ['link', 'image'],
  ['clean'],
]

const FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'align',
  'list',
  'bullet',
  'blockquote',
  'code-block',
  'link',
  'image',
]

const useStyles = makeStyles({
  root: {
    '& .ql-toolbar': {
      borderRadius: '8px 8px 0 0',
    },
    '& .ql-container': {
      borderRadius: '0 0 8px 8px',
      fontFamily: 'inherit',
      fontSize: '14px',
    },
    '& .ql-editor': {
      minHeight: 240,
      maxHeight: 420,
      overflowY: 'auto',
    },
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 280,
    border: `1px solid ${colors.graylight}`,
    borderRadius: 8,
  },
})

let ReactQuill = null

// O Quill acessa `document` ao ser importado, então só carrega no client (SSR)
const loadQuill = () => {
  if (ReactQuill) return ReactQuill

  // eslint-disable-next-line global-require
  ReactQuill = require('react-quill')
  const { Quill } = ReactQuill

  // Alinhamento como style inline: o backend remove classes (ql-align-*)
  Quill.register(Quill.import('attributors/style/align'), true)

  return ReactQuill
}

const RichTextEditor = ({ value, onChange, placeholder = '' }) => {
  const classes = useStyles()
  const [Editor, setEditor] = useState(() => ReactQuill)

  useEffect(() => {
    if (!Editor) setEditor(() => loadQuill())
  }, [])

  const modules = useMemo(() => ({ toolbar: TOOLBAR }), [])

  if (!Editor) {
    return (
      <Box className={classes.loading}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  return (
    <Box className={classes.root}>
      <Editor
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
      />
    </Box>
  )
}

export default RichTextEditor
